/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.223.0-v202611042108-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqMonitorsApiClass {
 
   constructor() {}

  /**
   * @summary Retrieve the current value of the specified monitor. All times are in milliseconds
   * @param {string} monitorPath - Path of the monitor to read
  */
  public getMonitor(
    {
      monitorPath
    } : {
      monitorPath: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (monitorPath === null || monitorPath === undefined) {
      throw new Error("'monitorPath' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors/${encodeURIComponent(String(monitorPath))}`
      .replace('{monitorPath}', encodeURIComponent(String(monitorPath)));
    const urlTemplate = `${baseUrl}/system/monitors/{monitorPath}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.MonitorOutputV1>;
  }

  /**
   * @summary Retrieve the documentation for all available monitors
  */
  public getMonitorDocumentation(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors/definitions`;
    const urlTemplate = `${baseUrl}/system/monitors/definitions`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.MonitorDefinitionsOutputV1>;
  }

  /**
   * @summary Retrieve the paths of all available monitors
  */
  public getMonitors(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors`;
    const urlTemplate = `${baseUrl}/system/monitors`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.MonitorsOutputV1>;
  }

  /**
   * @summary Update a gauge
  */
  public postGaugeData(
    body?: models.GaugeDatumV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors/gauge`;
    const urlTemplate = `${baseUrl}/system/monitors/gauge`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Increment a meter
  */
  public postMeterData(
    body?: models.MeterDatumV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors/meter`;
    const urlTemplate = `${baseUrl}/system/monitors/meter`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Post monitor data
  */
  public postMonitorData(
    body: models.MonitorInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors`;
    const urlTemplate = `${baseUrl}/system/monitors`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Update a timer
  */
  public postTimerData(
    body: models.TimerDatumV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/system/monitors/timer`;
    const urlTemplate = `${baseUrl}/system/monitors/timer`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

}


export const sqMonitorsApi = new sqMonitorsApiClass();

export type sqMonitorsApiEndpoints = {
  'getMonitor': {
    method: 'get';
    path: '/system/monitors/${encodeURIComponent(String(monitorPath))}';
    response: models.MonitorOutputV1;
  };
  'getMonitorDocumentation': {
    method: 'get';
    path: '/system/monitors/definitions';
    response: models.MonitorDefinitionsOutputV1;
  };
  'getMonitors': {
    method: 'get';
    path: '/system/monitors';
    response: models.MonitorsOutputV1;
  };
  'postGaugeData': {
    method: 'post';
    path: '/system/monitors/gauge';
    response: models.StatusMessageBase;
  };
  'postMeterData': {
    method: 'post';
    path: '/system/monitors/meter';
    response: models.StatusMessageBase;
  };
  'postMonitorData': {
    method: 'post';
    path: '/system/monitors';
    response: models.StatusMessageBase;
  };
  'postTimerData': {
    method: 'post';
    path: '/system/monitors/timer';
    response: models.StatusMessageBase;
  };
};

type ApiGetMonitorResponse = models.MonitorOutputV1;
export function GetMonitorQueryKey(
  params: Parameters<typeof sqMonitorsApi.getMonitor>[0],
) {
  return ['sqMonitorsApi', 'getMonitor', params] as const;
}

export function useApiGetMonitorQuery(
  params: Parameters<typeof sqMonitorsApi.getMonitor>[0],
  options?: Omit<UseQueryOptions<ApiGetMonitorResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetMonitorResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetMonitorQueryKey(params),
    queryFn: () =>
      sqMonitorsApi.getMonitor(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetMonitorDocumentationResponse = models.MonitorDefinitionsOutputV1;
export function GetMonitorDocumentationQueryKey(
) {
  return ['sqMonitorsApi', 'getMonitorDocumentation'] as const;
}

export function useApiGetMonitorDocumentationQuery(
  options?: Omit<UseQueryOptions<ApiGetMonitorDocumentationResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetMonitorDocumentationResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetMonitorDocumentationQueryKey(),
    queryFn: () =>
      sqMonitorsApi.getMonitorDocumentation(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetMonitorsResponse = models.MonitorsOutputV1;
export function GetMonitorsQueryKey(
) {
  return ['sqMonitorsApi', 'getMonitors'] as const;
}

export function useApiGetMonitorsQuery(
  options?: Omit<UseQueryOptions<ApiGetMonitorsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetMonitorsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetMonitorsQueryKey(),
    queryFn: () =>
      sqMonitorsApi.getMonitors(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiPostGaugeDataResponse = models.StatusMessageBase;
type ApipostGaugeDataMutationParams = Parameters<typeof sqMonitorsApi.postGaugeData> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMonitorsApi.postGaugeData>;
type ApipostGaugeDataMutationVariables = models.GaugeDatumV1 | undefined;

export function useApiPostGaugeDataMutation(
  options?: Omit<UseMutationOptions<ApiPostGaugeDataResponse, AxiosError<SeeqErrorData>,
    ApipostGaugeDataMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPostGaugeDataResponse, AxiosError<SeeqErrorData>,
  ApipostGaugeDataMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApipostGaugeDataMutationVariables) =>
      sqMonitorsApi.postGaugeData(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiPostMeterDataResponse = models.StatusMessageBase;
type ApipostMeterDataMutationParams = Parameters<typeof sqMonitorsApi.postMeterData> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMonitorsApi.postMeterData>;
type ApipostMeterDataMutationVariables = models.MeterDatumV1 | undefined;

export function useApiPostMeterDataMutation(
  options?: Omit<UseMutationOptions<ApiPostMeterDataResponse, AxiosError<SeeqErrorData>,
    ApipostMeterDataMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPostMeterDataResponse, AxiosError<SeeqErrorData>,
  ApipostMeterDataMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApipostMeterDataMutationVariables) =>
      sqMonitorsApi.postMeterData(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiPostMonitorDataResponse = models.StatusMessageBase;
type ApipostMonitorDataMutationParams = Parameters<typeof sqMonitorsApi.postMonitorData> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMonitorsApi.postMonitorData>;
type ApipostMonitorDataMutationVariables = models.MonitorInputV1;

export function useApiPostMonitorDataMutation(
  options?: Omit<UseMutationOptions<ApiPostMonitorDataResponse, AxiosError<SeeqErrorData>,
    ApipostMonitorDataMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPostMonitorDataResponse, AxiosError<SeeqErrorData>,
  ApipostMonitorDataMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApipostMonitorDataMutationVariables) =>
      sqMonitorsApi.postMonitorData(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiPostTimerDataResponse = models.StatusMessageBase;
type ApipostTimerDataMutationParams = Parameters<typeof sqMonitorsApi.postTimerData> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqMonitorsApi.postTimerData>;
type ApipostTimerDataMutationVariables = models.TimerDatumV1;

export function useApiPostTimerDataMutation(
  options?: Omit<UseMutationOptions<ApiPostTimerDataResponse, AxiosError<SeeqErrorData>,
    ApipostTimerDataMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiPostTimerDataResponse, AxiosError<SeeqErrorData>,
  ApipostTimerDataMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApipostTimerDataMutationVariables) =>
      sqMonitorsApi.postTimerData(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
